const MembershipServiceApp = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../MembershipServiceApp.vue"
  );
const Home = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/Home.vue"
  );
const MembershipManage = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/MembershipManage.vue"
  );

const AdditionalService = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/AdditionalService.vue"
  );
import ServiceInit from "../views/membership/ServiceInit.vue";

export const CAFE24_ROUTES = [
  {
    path: "/",
    name: "BasicHome",
    redirect: {
      name: "MembershipServiceApp",
    },
  },
  {
    path: "/membership",
    redirect: {
      name: "ServiceInit",
    },
    name: "MembershipServiceApp",
    component: MembershipServiceApp,
    children: [
      {
        path: "/membership/init",
        name: "ServiceInit",
        component: ServiceInit,
      },
      {
        path: "/membership/:mall_id/Home",
        name: "Home",
        component: Home,
      },
      {
        path: "/membership/:mall_id/membershipManage",
        name: "MembershipManage",
        component: MembershipManage,
      },
      {
        path: "/membership/:mall_id/additionalService",
        name: "AdditionalService",
        component: AdditionalService,
        props: true,
      },
    ],
  },
];
